import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";
import React from 'react';
import { TextareaPoint, Name, Textarea } from './styles';
export default function TextareaField(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      required = _ref.required,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(TextareaPoint, null, /*#__PURE__*/React.createElement(Name, {
    htmlFor: id
  }, label || name), /*#__PURE__*/React.createElement(Textarea, {
    id: id,
    name: name || id,
    placeholder: placeholder || label || name,
    required: required,
    disabled: disabled
  }));
}